<template>
  <div class="r_page">
    <el-select
        :value="saleEntity"
        @input="$emit('update:saleEntity', $event)"
        placeholder="please select your zone">
      <el-option
          v-for="item in optsSaleEntity"
          :key="item.value"
          :label="item.label"
          :value="item.value"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import * as _ from 'lodash';
import {OptSaleEntity} from "@/utils";
import {SaleEntityType} from "@/utils/constants";

export default {
  data() {
    return {
      defaultSaleEntity: [SaleEntityType.DFDD, SaleEntityType.YG],
      optsSaleEntity: [],
    }
  },
  props: ['saleEntity', 'useAll'],
  mounted() {
    if (this.useAll) {
      this.defaultSaleEntity.push(SaleEntityType.None);
    }
    this.optsSaleEntity = _.filter(OptSaleEntity, (item) => _.includes(this.defaultSaleEntity, item.value));
  },
  emits: ["update:saleEntity"],
}
</script>

<style scoped>
</style>
